// src/components/admin/AdminCustomers.js
import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { useApp } from '../../lib/AppContext';

const TIER_COLORS  = { stone:'#888', crystal:'#4a9edd', elite:'#4cca74' };
const ROLE_COLORS  = { customer:'#555', staff:'#f0a500', admin:'#4cca74' };

export default function AdminCustomers() {
  const { showToast } = useApp();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    supabase.from('profiles').select('*').order('created_at', { ascending: false })
      .then(({ data }) => { setCustomers(data || []); setLoading(false); });
  }, []);

  const updateRole = async (id, role) => {
    await supabase.from('profiles').update({ role }).eq('id', id);
    setCustomers(c => c.map(x => x.id === id ? { ...x, role } : x));
    showToast(`Role updated to ${role}`, 'success');
  };

  const filtered = customers.filter(c =>
    !search || c.email?.includes(search) || c.full_name?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:300 }}><div className="spinner" /></div>;

  return (
    <div className="page-container" style={{ padding:'32px 24px' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.8rem', letterSpacing:'.05em' }}>Customers ({customers.length})</h2>
      </div>

      <input className="input-field" placeholder="Search by email or name…" value={search} onChange={e => setSearch(e.target.value)} style={{ marginBottom:16, maxWidth:360 }} />

      <div style={{ background:'#111', borderRadius:16, border:'1px solid rgba(255,255,255,.07)', overflow:'hidden' }}>
        {filtered.length === 0 && <div style={{ textAlign:'center', padding:'3rem', color:'#555' }}>No customers found</div>}
        {filtered.map(c => (
          <div key={c.id} style={{ padding:'14px 20px', borderBottom:'1px solid rgba(255,255,255,.04)' }}>
            <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:6 }}>
              <div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.9rem', fontWeight:700, color:'#f4f4f4' }}>
                  {c.full_name || c.email?.split('@')[0]}
                </div>
                <div style={{ fontSize:'.75rem', color:'#555', marginTop:1 }}>{c.email}</div>
              </div>
              <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                <span style={{ fontSize:'.7rem', color:TIER_COLORS[c.loyalty_tier], fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, letterSpacing:'.06em', textTransform:'uppercase' }}>
                  {c.loyalty_tier}
                </span>
                <span style={{ fontSize:'.68rem', background:`${ROLE_COLORS[c.role]}20`, color:ROLE_COLORS[c.role], fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, padding:'2px 8px', borderRadius:10, letterSpacing:'.06em', textTransform:'uppercase' }}>
                  {c.role}
                </span>
              </div>
            </div>
            <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
              <span style={{ fontSize:'.75rem', color:'#4cca74' }}>⭐ {c.loyalty_points} pts</span>
              <span style={{ color:'#333' }}>·</span>
              <span style={{ fontSize:'.75rem', color:'#444' }}>{c.preferred_country}</span>
              <span style={{ color:'#333' }}>·</span>
              <span style={{ fontSize:'.75rem', color:'#444' }}>Joined {new Date(c.created_at).toLocaleDateString()}</span>
              {c.role !== 'admin' && (
                <div style={{ display:'flex', gap:5, marginLeft:'auto' }}>
                  {['customer','staff','admin'].filter(r => r !== c.role).map(role => (
                    <button key={role} onClick={() => {
                      if (role === 'admin' && !window.confirm(`Grant admin powers to ${c.email}?`)) return;
                      updateRole(c.id, role);
                    }} style={{ padding:'3px 10px', border:`1px solid ${ROLE_COLORS[role]}50`, borderRadius:10, background:'none', color:ROLE_COLORS[role], fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.7rem', fontWeight:700, letterSpacing:'.06em', textTransform:'uppercase', cursor:'pointer' }}>
                      → {role}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
